/**
 * taskStatuses — shared constants for the task status + priority dimensions.
 *
 * Backend accepts `status` as a free string but documents the canonical set
 * as `todo | in_progress | done` (see TaskIn / TaskUpdate in backend/server.py).
 * Keeping the labels and tone hints here lets the Kanban and Priority views
 * stay in sync without duplicating the mapping.
 */

export const TASK_STATUSES = [
  { key: "todo",        label: "Nuevas",       labelEn: "New",         tone: "stone"   },
  { key: "in_progress", label: "En progreso",  labelEn: "In progress", tone: "amber"   },
  { key: "done",        label: "Completadas",  labelEn: "Completed",   tone: "emerald" },
];

export const TASK_STATUS_KEYS = TASK_STATUSES.map(s => s.key);

export const PRIORITY_ORDER = ["alta", "media", "baja"];

export const PRIORITY_LABEL = {
  alta:  { es: "Alta",   en: "High"   },
  media: { es: "Media",  en: "Medium" },
  baja:  { es: "Baja",   en: "Low"    },
};

// Tailwind classes for the priority badge inside a task card.
export const PRIORITY_BADGE_CLASS = {
  alta:  "bg-red-50 text-red-700 border-red-200",
  media: "bg-amber-50 text-amber-700 border-amber-200",
  baja:  "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export function priorityLabel(prio, lang = "es") {
  const key = prio || "media";
  return PRIORITY_LABEL[key]?.[lang] || key;
}

export function statusLabel(key, lang = "es") {
  const s = TASK_STATUSES.find(x => x.key === key);
  if (!s) return key;
  return lang === "en" ? s.labelEn : s.label;
}
